export const googleDriveService = {
    async getAccessToken(code) {
        try {
            const response = await fetch(
                process.env.VUE_APP_GOOGLE_URL + '/token',
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    },
                    body: new URLSearchParams({
                        code,
                        client_id: process.env.VUE_APP_CLIENTID,
                        client_secret: process.env.VUE_APP_CLIENT_SECRET,
                        redirect_uri: process.env.VUE_APP_REDIRECT_URI,
                        grant_type: 'authorization_code'
                    }),
                }
            )
            return response
        } catch (error) {
            return error
        }
    },
    async validateAccessToken(accessToken) {
        const response = await fetch(`${process.env.VUE_APP_GOOGLE_DRIVE_URL.replaceAll('drive', '')}oauth2/v1/tokeninfo?access_token=${accessToken}`);
        if (response.ok) {
            const data = await response.json();
            return data
        } else {
            return response
        }
    },
    async getFilesFromDrive(access_token, params = {}) {
        params = Object.keys(params).reduce((acc, key) => {
            if (params[key] !== undefined) {
                acc[key] = params[key]
            }
            return acc
        }, {})
        const paramsToFetch = new URLSearchParams({
            fields: 'nextPageToken, files(id,name,webContentLink,mimeType,iconLink,createdTime,size)',
            pageSize: params.pageSize ? params.pageSize : 12,
            ...params
        }).toString();

        try {
            const response = await fetch(
                process.env.VUE_APP_GOOGLE_DRIVE_URL + `/v3/files?${paramsToFetch}`,
                {
                    method: 'GET',
                    headers: {
                        Authorization: `Bearer ${access_token}`
                    },
                }
            )
            return response
        } catch (error) {
            return error
        }
    },
    async getFileFromId(access_token, fileId) {
        try {
            const response = await fetch(
                process.env.VUE_APP_GOOGLE_DRIVE_URL + `/v3/files/${fileId}?alt=media`,
                {
                    method: 'GET',
                    headers: {
                        Authorization: `Bearer ${access_token}`
                    },
                }
            )
            return response
        } catch (error) {
            return error
        }
    },
    async exportFileFromId(access_token, fileId, format) {
        try {
            const response = await fetch(
                process.env.VUE_APP_GOOGLE_DRIVE_URL + `/v3/files/${fileId}/export?mimeType=${format}`,
                {
                    method: 'GET',
                    headers: {
                        Authorization: `Bearer ${access_token}`
                    },
                }
            )
            return response
        } catch (error) {
            return error
        }
    },
}